import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";

const RegionAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const type = location.state.type;
  const id = location?.state?.id?.location?.id;

  const data = location?.state?.data;
  const [regionOptions, setRegionOptions] = useState([]);




  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      regionname: "",
      location: "",

    },
  });


  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res.roles)) {
      // 🔹 Convert API data to Select options
      const options = res.roles.map((region) => ({
        value: region.id,
        label: region.name,
      }));
      setRegionOptions(options);

      // 🔹 If you also want to preselect a region (e.g. from user profile)
      const regionId = res?.roles?.id || null; // adjust key as per API
      if (regionId) {
        const selected = options.find((opt) => opt.value === regionId);
        if (selected) {
          setValue("region", selected);
          console.log("ddd", selected);

        }
      }
    }
  }





  const addAdmin = async () => {
    const values = getValues(); // 👈 get all form field values

    let payload = {
      region_id: values.regionname.value,
      location: values.location,
      type: 1,
      status: 1,
    };
    if (type == "add") {
      let res = await post(URLS.STORE_LOCATION, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/region");
      }
    } else {
      let res = await post(URLS.UPDATELOCATION + id, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/region");
      }
    }
    console.log("Payload:", payload);
  };




  useEffect(() => {
    if (type != "add") {
      // console.log("ll", data);
      setValue("regionname", {
        value: data?.region?.id,
        label: data?.region?.name,
      });
      setValue("location", data?.location?.name);

    }
    regionList();
  }, [])




  const regionoption = [
    { value: "north", label: "North Region" },
    { value: "south", label: "South Region" },
    { value: "east", label: "East Region" },
    { value: "west", label: "West Region" },
    { value: "central", label: "Central Region" },
  ];

  const locationoption = [
    { value: "chennai", label: "Chennai" },
    { value: "bangalore", label: "Bangalore" },
    { value: "mumbai", label: "Mumbai" },
    { value: "delhi", label: "Delhi" },
    { value: "hyderabad", label: "Hyderabad" },
  ];



  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#D9D9D9",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };


  const onSubmit = (data) => {
    addAdmin(data)
    console.log("Submitted Data:", data);

    if (isEditMode) {
      console.log("Updating user...");
    } else {
      console.log("Adding new user...");
    }
  };




  return (
    <div>
      <Topbar
        header="Region"
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1 px-4 py-3">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >

          <div className="col-md-5">
            <Controller
              control={control}
              name="regionname"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Region Name
                  </label>
                  <Select
                    {...field}
                    options={regionOptions}
                    placeholder="Select Region"
                    isSearchable
                    // onChange={(val) => field.onChange(val)}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("location", "");
                    }} // ✅ store full option
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.regionname && (
                    <p style={{ color: "red" }}>{errors.regionname.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="location"
              rules={{ required: "Location is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Location
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Location"
                    disabled={isViewMode}
                  />
                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location.message}</p>
                  )}
                </div>
              )}
            />
          </div>

        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
            >
              {isEditMode ? "Save" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegionAdd;
